window.fisherAnalytics.users = {
    version: '1.0.0',
    process: function (body, response, config) {
        var data;
        if (response.responseText.indexOf(config.responseText) !== -1) {
            try {

                //The new endpoint returns HTML and exposes a JS object called accountDropdown
                if(window.accountDropdown && !config.options.useLegacy){
                    data = window.accountDropdown;
                } else {
                    //The old endpoint returns JSON
                    data = JSON.parse(response.responseText);

                    // Store legacy response in sessionStorage when using legacy mode
                    if (config.options.useLegacy) {
                        sessionStorage.setItem('fisherUserDetails', response.responseText);
                    }
                }
                if (data && response.status === 200) {
                    window.digitalDataManager.fishersci.setUser(window.accountDropdown.userDetails);

                    // Store user details in sessionStorage
                    if (window.accountDropdown && window.accountDropdown.userDetails) {
                        sessionStorage.setItem('fisherUserDetails', JSON.stringify(window.accountDropdown.userDetails));
                    }
                }
                document.dispatchEvent(new CustomEvent("userDetailsAvailable", {detail: {userDetails: window.accountDropdown.userDetails}}));
            } catch (e) {
                window.fisherAnalytics.utils.log("issue with users data global ui intercept: " + e);
            }
        }
    },
    loginInitiated: function (body, response, config) {
        document.dispatchEvent(new CustomEvent("loginInitiate"));
    },
    login: function (body, response, config) {
        let errorMessage = "";
        let responseTextJson;
        if(response.responseText.indexOf('"loginSuccess":true') !== -1) {
            document.dispatchEvent(new CustomEvent("loginSuccessful"));
            if (config.pauseExecution) {
                return new Promise(function(resolve) {
                    setTimeout(function () {
                        resolve();
                    }, config.pauseExecution);
                });
            }
        } else {
            if(response.responseText.indexOf('"errorMessage":') !== -1) {
                responseTextJson = JSON.parse(response.responseText);
                document.dispatchEvent(new CustomEvent("loginError", {detail: {errorDescription: responseTextJson.errorMessage}}));
            }
        }
    }
};